module.exports = __webpack_public_path__ + "media/hiatal hernia.bd163fd1.wav";